import gql from 'graphql-tag';

const TOGGLE_SIM_STATE = gql`
  mutation Mutation($simNumber: String!) {
    toggleSimState(simNumber: $simNumber) {
      code
    }
  }
`;

export default TOGGLE_SIM_STATE;
